import { IonBackButton, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonTitle, IonToast, IonToggle, IonToolbar } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React from 'react';

class OperacoesFiltroLojas extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            lojas: [...this.props.lojas],
            lojasCores: {...this.props.lojasCores},
            showToast: false
        }
    }

    changeToggle(checked: boolean, valor: string) {
        if (checked) {
            this.state.lojas.push(valor);
            this.setState({ lojas: [...this.state.lojas] });
        }
        else {
            //console.log(this.props.lojas.filter((loja:any)=>loja != valor));
            this.setState({ lojas: [...this.state.lojas.filter((loja: any) => loja != valor)] });
        }
    }

    changeLojaCor(item:any, event:any) {
        this.state.lojasCores[item] = event.target.value;
        this.setState({ lojasCores: {...this.state.lojasCores} });
        this.props.setLojasCores(this.state.lojasCores);
        window.localStorage.setItem("lojasCores", JSON.stringify(this.state.lojasCores));
    }

    render() {
        return (
            <>
                <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonToolbar color='primary' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <IonButtons slot='start' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonButton onClick={() => this.props.setShowModalFiltroLojas(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonIcon icon={arrowBack} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
                            </IonButton>
                        </IonButtons>
                        <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonLabel className="ion-text-wrap" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Filtro de Lojas</IonLabel>
                        </IonTitle>
                        <IonButtons slot='end' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonButton onClick={() => { this.setState({ lojas: [] }); }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                Desmarcar todos
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        {JSON.parse(window.localStorage.getItem("lojas") || "[]").map((valor: any, index: any) => (
                            <IonItem key={'listaFiltroOperacoes'+index} lines='full' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{valor.clienteLojaNome}</IonLabel>
                                <IonToggle value={valor.clienteLojaId} slot='start' color="primary" checked={this.state.lojas.includes(valor.clienteLojaId)} onIonChange={e => this.changeToggle(e.detail.checked, e.detail.value)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
                                    <input type="color" value={Object.hasOwn(this.props.lojasCores || {}, valor.clienteLojaId)?this.props.lojasCores[valor.clienteLojaId]:"#FFFFFF"} onChange={e => this.changeLojaCor(valor.clienteLojaId, e)}></input>
                            </IonItem>

                        ))}
                    </IonList>
                    <br />
                    <IonToast
                        isOpen={this.state.showToast}
                        position="middle" //top, bottom, middle
                        onDidDismiss={() => this.setState({ showToast: false })}
                        message={'Selecione ao menos uma loja'}
                        duration={2000}
                    />
                </IonContent>
                <IonFooter placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <IonButton expand='full' onClick={() => {
                        if (this.state.lojas.length > 0) {
                            this.props.setLojas([...this.state.lojas]);
                            if (this.props.updateDataFunction) this.props.updateDataFunction(this.state.lojas);
                            window.localStorage.setItem("lojasFiltradas", JSON.stringify([...this.state.lojas]));
                            this.props.setShowModalFiltroLojas(false);
                        }
                        else {
                            this.setState({ showToast: true });
                        }
                    }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Filtrar</IonButton>
                </IonFooter>
            </>);
    }
}

export default OperacoesFiltroLojas;

